import '../App.css';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box, Grid } from '@mui/material';

import background_video from '../assets/video_cover.mp4'
import NFT_1 from '../assets/NFT_1.jpg';
import NFT_2 from '../assets/NFT_2.jpg';
import NFT_3 from '../assets/NFT_3.jpg';

import FeatureCard from './feature-card';
import ResponsiveAppBar from './app-bar';
import NftCard from './nft-card';

function Home() {
    const navigate = useNavigate();
    const [width, setWindowWidth] = useState(0);

    useEffect(() => {

        const updateDimensions = () => {
            const width = window.innerWidth;
            setWindowWidth(width);
        }

        updateDimensions();
        window.addEventListener("resize", updateDimensions);

        return () =>
            window.removeEventListener("resize", updateDimensions);
    }, []);

    const isMobile = () => {
        return width < 850;
    }

    const openEPANNftDetail = () => {
        // window.open('https://raonwars.gitbook.io/raonpaper/gameplay/nfts/exclusive-presale-access-nft', "_blank", "noreferrer");
        navigate('/marketplace', {
        });
    }

    const openLHNNftDetail = () => {
        window.open('https://raonwars.gitbook.io/raonpaper/gameplay/nfts/legendary-hero-nft', "_blank", "noreferrer");
    }

    const openEBNNftDetail = () => {
        window.open('https://raonwars.gitbook.io/raonpaper/gameplay/nfts/epic-building-nft', "_blank", "noreferrer");
    }

    const openTweetPrompt = () => {
        window.open('https://twitter.com/intent/tweet?text=Join%20the%20RAONWARS%20Community%20-%20Conquer,%20Connect,%20and%20Collaborate!%0a%0aOfficial%20Website:%20raonwars.web.app%0a%0a@Raonwars', "_blank", "noreferrer");
    }

    const getWlSpot = () => {
        navigate('/wlspot', {
        });
    }

    return (
        <div className='App'>
            <div className="App-header">
                <ResponsiveAppBar isMobile={isMobile()} />
                <video className={width < 1280 ? 'background_video video-full-height' : 'background_video video-full-width'} autoPlay loop muted>
                    <source src={background_video} type='video/mp4' />
                </video>
                <div className="centered">
                    <div className={isMobile() ? 'title-logo-mobile' : 'title-logo'}>RAONWARS</div>
                    <p className={isMobile() ? 'body-text-mobile' : 'body-text'}>Prepare to embark on an epic journey into the realm of strategic PvP battles with RAONWARS. Immerse yourself in a captivating gaming experience that elevates beloved strategy and battle elements to unprecedented heights.</p>
                </div>
            </div>
            <div className='App-summary'>
                <div className='wood-divider'></div>
                <div className='wood-background-light'>
                    <Grid>
                        <Box sx={{ flexGrow: 1 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={6} lg={6} key={1}>
                                    <div className='summary-card'>
                                        <div className='summary-card-title'>WHAT'S RAONWARS?</div>
                                        <div className='summary-card-content'>Raonwars offers an unparalleled and immersive gaming experience, fueled by the coveted and perpetually limited - $RAON. Our goal is to establish ourselves as one of the pioneering mainstream games within Web3 by prioritizing unwavering player engagement. We achieve this by maintaining a straightforward game concept that is easy to grasp, ensuring that players can dive into the action quickly. Furthermore, we understand the value of players' time, so we have crafted gameplay that is not only immersive but also optimizes playtime, making every moment spent in the game vital and rewarding.</div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} key={2}>
                                    <Grid container className={isMobile() ? 'tokenomics-card-mobile' : 'tokenomics-card'}>
                                        <Grid item xs={12} md={6} className={isMobile() ? 'tokenomics-card-content' : 'tokenomics-card-title'}>TOKENOMICS<br />
                                            Total Supply: 1,000,000,000<br />
                                            LIQUIDITY POOL (75%)<br />
                                            Presale | 30%<br />
                                            Public | 45%</Grid>
                                        <Grid item xs={12} md={6} className={isMobile() ? 'tokenomics-card-content' : 'tokenomics-card-title'}>GROWTH FUND (25%)<br />
                                            Game development | 10%<br />
                                            Marketing | 7%<br />
                                            CEX Listings | 5%<br />
                                            Team | 3%</Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                    <Grid>
                        <Box sx={{ flexGrow: 1 }}>
                            <div className='title-logo-mobile'>GAME CONCEPT</div>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={6} lg={3} key={1}>
                                    <FeatureCard title="Set Tier" content="It all begins on your exclusive island, where every week you will receive a curated list of tournament tiers. Each tier is associated with a specific $RAON wager requirement. Your choice of tier and the amount of $RAON you choose to wager determines your in-game development budget."></FeatureCard>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={3} key={2}>
                                    <FeatureCard title="Building" content="Once you have determined your currency allocation, you will have the freedom to strategically develop a formidable lineup for both your island's defense and offense. Your ultimate objective is to safeguard your CHEST, which holds your precious $RAON wager."></FeatureCard>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={3} key={3}>
                                    <FeatureCard title="Battles" content="Every weekend, the RAONWARS battles will take place. Engage in thrilling clashes against randomly selected opponents, as your offenses and defenses go head to head in intense combat."></FeatureCard>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={3} key={3}>
                                    <FeatureCard title="Alliances&Diplomacy" content="Players can form alliances with other players to coordinate attacks, share resources, and strategize against common foes. Diplomacy plays a crucial role in building alliances and negotiating treaties to strengthen positions and secure mutual benefits."></FeatureCard>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </div>

            </div>
            <div className='App-summary'>
                <div className='wood-divider'></div>
                <Grid className='wood-background-dark'>
                    <Box sx={{ flexGrow: 1 }}>
                        <div className='title-logo-mobile'>MARKET PLACE</div>
                        <Grid container spacing={2} sx={{ alignItems: "stretch" }}>
                            <Grid item xs={12} sm={12} md={4} sx={{ marginBottom: "50px" }}>
                                <NftCard image={NFT_1} handleClick={openEPANNftDetail} title="Exclusive Presale Access NFT" content="The Exclusive Presale Access NFT is a limited-edition non-fungible token (NFT) that grants its holder exclusive privileges and benefits within the RAONWARS ecosystem. By owning this NFT, you become part of an elite group with early access to the presale of our game's native token. The EPA (Exclusive Presale Access NFT) limited sale will open for all members on July 16th, 9PM EST."></NftCard>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} sx={{ marginBottom: "50px" }}>
                                <NftCard image={NFT_2} handleClick={openLHNNftDetail} title="Legendary Hero NFT" content="The Legendary Hero NFT is a prestigious and limited-edition non-fungible token (NFT) that represents a mighty hero within the RAONWARS universe. These heroes are renowned for their exceptional skills, unmatched prowess, and captivating backstories. By owning a Legendary Hero NFT, you gain exclusive access to deploy these legendary figures on the battlefield and harness their extraordinary powers."></NftCard>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} sx={{ marginBottom: "50px" }}>
                                <NftCard image={NFT_3} handleClick={openEBNNftDetail} title="Epic Building NFT" content="The Epic Building NFT is a highly coveted non-fungible token (NFT) that represents a monumental and strategically significant structure within RAONWARS. These buildings are renowned for their advanced functionalities, specialized benefits, and unparalleled contributions to the growth and defense of your base. By owning an Epic Building NFT, you gain access to exclusive features that will elevate your base-building capabilities to unprecedented heights."></NftCard>
                            </Grid>
                        </Grid>
                        <div className={isMobile() ? 'body-text-mobile end-text' : 'body-text end-text'}>Join our vibrant community of passionate gamers, strategists, and enthusiasts. Participate in engaging events, connect with fellow players, and contribute to the evolution of the RAONWARS universe. Are you ready to forge your legacy? Unleash your strategic mastery, conquer opponents, and become the ultimate champion in RAONWARS. Prepare for battle and join us on this thrilling adventure!</div>
                        <button className='main-button' onClick={getWlSpot}>Get WL SPOT!</button>
                    </Box>
                </Grid>
            </div>
        </div>
    );
}

export default Home;
